import Vue    from "vue"
import Router from "vue-router"
import store  from "@/store"
import accountRoutes from "./account-routes"
import committeeRoutes from "./committee-routes"
import formRoutes from "./form-routes"
import teacherRoutes from "./teacher-routes"
import studentRoutes from "./student-routes"
import eventRoutes from "./event-routes"
import registrationRoutes from "./registration-routes"
import signupRoutes from "./signup-routes"
import paymentRoutes from "./payment-routes"
import helperRoutes from "./helper-routes"
import groupRoutes from "./group-routes"
import { authenticate } from "@/api/authenticate"

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "home",
            component: () => import(/* webpackChunkName: "home" */ "../views/home/Home.vue"),
            meta: { requiresAuth: true }
        },
        ...accountRoutes,
        ...committeeRoutes,
        ...formRoutes,
        ...teacherRoutes,
        ...studentRoutes,
        ...eventRoutes,
        ...registrationRoutes,
        ...signupRoutes,
        ...paymentRoutes,
        ...helperRoutes,
        ...groupRoutes
    ],
    linkActiveClass: "active",
})

router.beforeEach((to, from, next) => {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.state.loggedIn && localStorage.token)
        authenticate({ redirect: { name: "login" } }).then(() => {
            next();
        });
    else if (!store.state.loggedIn && to.matched.some(record => record.meta.requiresAuth))
        next({
            path: "/account/login",
            query: { redirect: to.fullPath }
        });
    else
        next();
});

export default router;